import { createRef, createElement, Component } from 'react';
import _get from 'lodash/get';
import { f as _defineProperty, e as _inheritsLoose, g as _assertThisInitialized } from './chunk-ad6ad343.js';
import createFocusTrap from 'focus-trap';

var convertToMs = function convertToMs(time) {
  if (/([0-9]*[.])?[0-9]+ms/.test(time)) {
    return parseFloat(time.replace('ms', ''));
  }

  if (/([0-9]*[.])?[0-9]+s/.test(time)) {
    return parseFloat(time.replace('s', '')) * 1000;
  }

  return 0;
};

var noop = function noop() {};

var TrapFocus = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TrapFocus, _React$Component);

  function TrapFocus() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      originalAriaHiddenValues: []
    });

    _defineProperty(_assertThisInitialized(_this), "fallbackFocus", createRef());

    _defineProperty(_assertThisInitialized(_this), "initialFocus", createRef());

    _defineProperty(_assertThisInitialized(_this), "wrapper", createRef());

    _defineProperty(_assertThisInitialized(_this), "trap", {
      activate: noop,
      deactivate: noop
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          delayToActivate = _this$props.delayToActivate,
          isActive = _this$props.isActive,
          usesPortal = _this$props.usesPortal; // @ts-ignore

      _this.trap = createFocusTrap(_this.wrapper.current, {
        initialFocus: _this.initialFocus.current,
        fallbackFocus: _this.fallbackFocus.current,
        escapeDeactivates: false,
        clickOutsideDeactivates: false
      });

      if (isActive) {
        if (delayToActivate) {
          setTimeout(_this.trap.activate, convertToMs(delayToActivate));
        } else {
          _this.trap.activate();
        }
      }

      if (usesPortal) {
        Array.from(_get(document, 'body.children', [])).forEach(function (child) {
          if (child.contains(_this.wrapper.current)) return;

          _this.setState(function (prevState) {
            return {
              originalAriaHiddenValues: [].concat(prevState.originalAriaHiddenValues || [], [child.getAttribute('aria-hidden')])
            };
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props2 = _this.props,
          delayToActivate = _this$props2.delayToActivate,
          isActive = _this$props2.isActive,
          usesPortal = _this$props2.usesPortal;
      var originalAriaHiddenValues = _this.state.originalAriaHiddenValues;

      if (isActive !== prevProps.isActive) {
        if (isActive) {
          if (delayToActivate) {
            setTimeout(_this.trap.activate, convertToMs(delayToActivate));
          } else {
            _this.trap.activate();
          }
        } else {
          _this.trap.deactivate();
        }

        if (usesPortal) {
          Array.from(_get(document, 'body.children', [])).forEach(function (child, i) {
            if (child.contains(_this.wrapper.current)) {
              return;
            }

            if (isActive) {
              child.setAttribute('aria-hidden', 'true');
              return;
            }

            if (originalAriaHiddenValues[i]) {
              child.setAttribute('aria-hidden', originalAriaHiddenValues[i]);
              return;
            }

            child.removeAttribute('aria-hidden');
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.trap.deactivate();
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var children = _this.props.children;
      return createElement("div", {
        ref: _this.wrapper
      }, children({
        fallbackFocusRef: _this.fallbackFocus,
        initialFocusRef: _this.initialFocus
      }));
    });

    return _this;
  }

  return TrapFocus;
}(Component);

_defineProperty(TrapFocus, "defaultProps", {
  isActive: false,
  usesPortal: false
});

export { TrapFocus as a };